module.exports = __webpack_public_path__ + "static/media/fly0050.b207df78.webp";